import React, { useState, useEffect, useRef } from "react";
import { ProgressBar } from "react-bootstrap";
import LoadMore from "elements/LoadMore";
import GameItem from "elements/gameElements/GameItem";
// import SearchBox from "elements/SearchBox";
import { Link, useParams, useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import api from "services/api";
import Translator, { __ } from "services/Translator";
import { gameTypeAPISlugs, gameTitles, gameTypeIcons } from "configs/gameTypes";
import ProviderFilterDropdown from "elements/gameElements/ProviderFilterDropdown";
import SortingDropdown from "elements/gameElements/SortingDropdown";

// import JackpotTicker from "elements/JackpotTicker";

export default function CategoryGames(props) {
  const params = useParams();
  const category = params.category;
  const history = useHistory();
  // const providers = props.providers;
  const selectedProviders = props.selectedProviders;
  const setSelectedProviders = props.setSelectedProviders;
  // const [selectedProviders, setSelectedProviders] = useState([]);

  const [providersModal, setProvidersModal] = useState(false);
  const closeAllModals = () => {
    setProvidersModal(false);
  };
  const toggleProviersModal = () => {
    setProvidersModal(!providersModal);
  };
  const toggleSelectedProvider = (providerId) => {
    var providersClone = JSON.parse(JSON.stringify(selectedProviders));
    if (providersClone.indexOf(providerId) === -1) {
      providersClone.push(providerId);
    } else {
      providersClone.splice(providersClone.indexOf(providerId), 1);
    }
    setSelectedProviders(providersClone);
    history.push("/games/all");
  };

  const clearAllProviders = () => {
    setSelectedProviders([]);
  };
  // const __ = (text) => text;

  const [searchStr, setSearchStr] = useState("");
  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const searchTextBox = useRef(null);

  // expand searcbar
  const [expandSearchBar, setExpandSearchBar] = useState(true);

  const toggleExpandedSearchBar = (force) => {
    if (expandSearchBar) {
      setSearchSuggestions([]);
      if (force === true) {
        setSearchStr("");
        setExpandSearchBar(false);
      } else {
        if (searchStr.length === 0) {
          setExpandSearchBar(false);
        }
      }
    } else {
      setExpandSearchBar(true);
      searchTextBox.current.focus();
    }
  };

  const getSearchSuggestions = async () => {
    if (searchStr.length >= 2) {
      var response = await api.get("/games/search-suggestions", {
        query: searchStr,
        // providers: props.selectedProviders,
        providers: [],
        extensiveInfo: true,
      });
      if (response.status === 200) {
        setSearchSuggestions(response.data);
      }
    } else {
      setSearchSuggestions([]);
    }
  };

  useEffect(() => {
    getSearchSuggestions();
  }, [searchStr]);

  const doSearchByGameName = (text) => {
    props.setSearchStr(text);
    toggleExpandedSearchBar(true);
    props.setSelectedProviders([]);
    history.push("/games/search");
  };

  //Getting Providers by category
  const [providers, setProviders] = useState([]);
  // const [selectedProviders, setSelectedProviders] = useState([]);
  const getProviders = async () => {
    var response = await api.get(
      "/games/providers/" + gameTypeAPISlugs[props.category]
    );
    if (response.status === 200) {
      // Filter out providers with gameCount = 0
      const filteredProviders = response.data.filter(
        (provider) => provider.gameCount > 0
      );
      setProviders(filteredProviders);
    }
  };
  useEffect(() => {
    getProviders();
    setSelectedProviders([]);
    // selectedProviders = [];
    // alert(props.category);
  }, [props.category]);

  return (
    <>
      <section className="categoryGames">
        <div className="section_headline game-headline-area margin_bottom_30">
          <div className="headline_text">
            {gameTypeIcons[props.category] ?? ""}
            {gameTitles[props.category] ?? ""}
          </div>
          <div className="filter-area">
            <SortingDropdown
              defaultSorting={props.gameSorting || "Default"}
              onSortingChange={props.setGameSorting}
            />
            <ProviderFilterDropdown
              providers={providers}
              selectedProviders={selectedProviders}
              setSelectedProviders={setSelectedProviders}
            />
          </div>
        </div>

        <div className="gamesLists ">
          {props.gameList.map((game, index) => (
            <GameItem
              game={game}
              isAuthenticated={props.isAuthenticated}
              landingType={props.landingType}
              key={index}
              props={props}
            />
          ))}
        </div>

        {props.showPagination && (
          <>
            <LoadMore
              className="play-games-btn"
              data={props.pagination}
              onPageChange={props.onPageChange}
            />

            <div className="gameLoadingProgress ">
              <div className="gameLoadingInfo text-white margin_bottom_15">
                {__("You've viewed")} {props.gameLoaded} {__("of")}{" "}
                {props.totalGame} {__("games")}
                {/* <div className="gameLoaded">{props.gameLoaded}</div>
                <div className="totalGame"> {props.totalGame}</div> */}
              </div>

              <ProgressBar
                className={
                  "games_count_progress margin_bottom_30 " + props.landingType
                }
                variant="success"
                now={(props.gameLoaded / props.totalGame) * 100}
              />
            </div>
          </>
        )}

        <Modal size="lg" show={providersModal} onHide={closeAllModals}>
          <Modal.Body className="providers_modal">
            <div onClick={closeAllModals} className="modal_close">
              <i className="fal fa-times"></i>
            </div>

            <div className="modal_headline">{__("Filter By Providers")}</div>
            <div className="providers_list">
              <Link
                hreflang={Translator.getSelectedLanguage().code}
                onClick={clearAllProviders}
                className={
                  "commonBtn small " +
                  (selectedProviders.length === 0 ? "active" : "inactive")
                }
              >
                {__("All Providers")}
              </Link>

              {providers.map((item, index) => (
                <Link
                  hreflang={Translator.getSelectedLanguage().code}
                  onClick={() => toggleSelectedProvider(item.provider_id)}
                  key={index}
                  className={
                    "commonBtn small " +
                    (item.name.length > 12 ? "smallText " : "") +
                    (selectedProviders.indexOf(item.provider_id) !== -1
                      ? "active"
                      : "inactive")
                  }
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </Modal.Body>
        </Modal>
      </section>
    </>
  );
}
